'use strict';

var polyfillJSON = require('../../vendor/JSON-js/json3');

module.exports = polyfillJSON;
